import { ReactNode } from 'react';
import { Trans } from 'react-i18next';

import { commonTranslationKeys } from '@dreryk/react-common';
import { ModalWidth, ShowModalEventInterceptor } from '@dreryk/react-components';

import { practitionerMedicalServiceTranslationKeys } from '../../../../translations';

type PractitionerMedicalServiceRemoveConfirmationEventInterceptorProps = {
   readonly children: ReactNode;
   readonly medicalServiceName: string;
   readonly practitionerName: string;
   readonly hasMorePractitioners: boolean;
};

export const PractitionerMedicalServiceRemoveConfirmationEventInterceptor = (
   props: PractitionerMedicalServiceRemoveConfirmationEventInterceptorProps
): JSX.Element => {
   return (
      <ShowModalEventInterceptor
         shouldShowModal
         modalWidth={ModalWidth.NORMAL}
         testId={'practitionerMedicalServiceRemoveConfirmation'}
         title={practitionerMedicalServiceTranslationKeys.remove.confirmation.title}
         confirmationButtonLabel={commonTranslationKeys.remove}
         content={
            <Trans
               i18nKey={
                  props.hasMorePractitioners
                     ? practitionerMedicalServiceTranslationKeys.remove.confirmation.content.manyPractitioners
                     : practitionerMedicalServiceTranslationKeys.remove.confirmation.content.onePractitioner
               }
               components={{ bold: <strong /> }}
               values={{
                  medicalServiceName: props.medicalServiceName,
                  practitionerName: props.practitionerName,
               }}
            />
         }
      >
         {props.children}
      </ShowModalEventInterceptor>
   );
};
